// extracted by mini-css-extract-plugin
export default {"cls1":"OaLePKG2tjo03IbuLfqO","cls2":"VkA75NGZCiwMgwQd80Rc OaLePKG2tjo03IbuLfqO"};